import styled from "styled-components";

export const RegisterCardContainer = styled.div`
    display: flex;
    padding: var(--Sizes---size-xl, 32px);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--Sizes---size-xl, 32px);
    max-width: 420px;
    align-self: stretch;
    border-radius: 12px;
    background: ${({ theme }) => theme.colors.theme.contentBg};
    box-shadow: ${({ theme }) => theme.shadows.card};
`;

export const RegisterCardTitle = styled.h1`
    color: ${({ theme }) => theme.colors.text.headings};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

export const RegisterCardBody = styled.div`
    display: flex;
    padding: var(--Sizes---size-regular, 16px) 0px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--Sizes---size-xl, 32px);
    align-self: stretch;
`;

export const RegisterCardProfilePictureContainer = styled.div`
    position: relative;
    display: flex;
    width: 128px;
    height: 128px;
    justify-content: center;
    align-items: center;
`;

export const RegisterCardProfilePicture = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
`;

export const RegisterCardInputContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const RegisterCardLabel = styled.label`
    color: ${({ theme }) => theme.colors.text.headings};
    font-size: 14px;
    font-weight: 500;
`;

export const RegisterCardInput = styled.input`
    display: flex;
    min-width: 200px;
    max-width: 800px;
    flex-direction: column;
    align-items: flex-start;
    background-color: transparent;
    align-self: stretch;
    padding: 8px;
    border: 1px solid ${({ theme }) => theme.colors.text.muted};
    border-radius: 32px;
    color: ${({ theme }) => theme.colors.text.headings};
`;

export const ChangeProfileButton = styled.button`
    position: absolute;
    bottom: 0;
    right: 0;
    background: ${({ theme }) => theme.colors.common.black};
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
`;

